import { c as _c } from "react/compiler-runtime";
import SocialFacebook from "#assets/icons/social/facebook.svg?react";
import SocialInstagram from "#assets/icons/social/instagram.svg?react";
import SocialLinkedin from "#assets/icons/social/linkedin.svg?react";
import { cn } from "#lib/utils.js";
import { jsx as _jsx } from "react/jsx-runtime";
const icons = {
  Facebook: SocialFacebook,
  Instagram: SocialInstagram,
  LinkedIn: SocialLinkedin
};
const sizeMap = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
  xl: "w-12 h-12"
};
export function Icon(t0) {
  const $ = _c(16);
  let className;
  let name;
  let props;
  let t1;
  let title;
  if ($[0] !== t0) {
    ({
      name,
      className,
      size: t1,
      title,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = name;
    $[3] = props;
    $[4] = t1;
    $[5] = title;
  } else {
    className = $[1];
    name = $[2];
    props = $[3];
    t1 = $[4];
    title = $[5];
  }
  const size = t1 === undefined ? "md" : t1;
  const IconComponent = icons[name];
  if (!IconComponent) {
    return null;
  }
  const sizeClass = typeof size === "number" ? `w-${size} h-${size}` : sizeMap[size];
  let t2;
  if ($[6] !== className || $[7] !== sizeClass) {
    t2 = cn(sizeClass, className);
    $[6] = className;
    $[7] = sizeClass;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = !title;
  const t4 = title ? "img" : "presentation";
  let t5;
  if ($[9] !== IconComponent || $[10] !== props || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== title) {
    t5 = /*#__PURE__*/_jsx(IconComponent, {
      className: t2,
      "aria-hidden": t3,
      "aria-label": title,
      role: t4,
      ...props
    });
    $[9] = IconComponent;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = title;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}